import { DeployEntryPointName } from '@block-explorer/entities';
import { WASM_DEPLOY } from './currency.tsx';

export const ExecutionTypesMap = {
  1: 'WASM', //"ModuleBytes"
  2: 'Contract call', //"StoredContractByHash"
  3: 'Contract call', //"StoredContractByName",
  4: 'Contract call', //"StoredVersionedContractByHash",
  5: 'Contract call', //"StoredVersionedContractByName",
  6: 'Native',
};

/**
 * Check if the Deploy is a transfer deploy by comparing native trasfer contract hash and entrypoint name, return TRUE
 * @param contractHash
 * @param entryPointName
 */
export const isTransferDeploy = (
  contractHash: string | null,
  entryPointName: string | null | undefined
) => {
  return (
    contractHash === config.native_transfer_contract_hash &&
    entryPointName === DeployEntryPointName.TRANSFER
  );
};

/**
 * Check if the Deploy is a WASM deploy, return TRUE
 * @param executionTypeId
 */
export const isWASMTransaction = (executionTypeId: number) => {
  return executionTypeId === WASM_DEPLOY;
};
